<template>
  <div id="modalUploadProductImages" class="modal fade" data-backdrop="static">
    <div
      class="modal-dialog modal-dialog-vertical-center modal-lg"
      :class="{ 'modal-max': max }"
    >
      <div class="modal-content bd-0 tx-14">
        <modal-loading
          :show="loading || modalLoading || listLoading"
        ></modal-loading>
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{ $t("outside.上传商品图片") }}
            <span
              v-if="imgRule && imgRule.isMust"
              class="tx-normal tx-12 tx-danger"
            >
              <template v-if="minSelected || maxSelected">
                ({{ $t("outside.图片数量限制") }}{{ minSelected }}
                <span v-if="minSelected != maxSelected"
                  >- {{ this.maxSelected }}</span
                >
                {{ $t("outside.张图片") }})
              </template>
              <template v-if="minSizeX || minSizeY">
                （{{ $t("outside.最小分辨率：") }}
                <span v-if="minSizeX" class="mg-r-5"
                  >{{ $t("outside.宽") }} {{ minSizeX }}px</span
                >
                <span v-if="minSizeY"
                  >{{ $t("outside.高") }} {{ minSizeY }}px</span
                >）
              </template>
            </span>
            <span v-else class="tx-normal tx-12 tx-danger">
              <template v-if="minSelected || maxSelected">
                ({{ $t("outside.图片数量限制") }}{{ minSelected }}
                <span v-if="minSelected != maxSelected"
                  >- {{ this.maxSelected }}</span
                >
                {{ $t("outside.张图片") }})
              </template>
            </span>
          </h6>
          <div>
            <button type="button" class="size" @click="changeSize">
              <i
                class="fa"
                :class="max ? 'fa-window-restore' : 'fa-window-maximize'"
              ></i>
            </button>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
        </div>
        <div class="modal-body pd-25">
          <!-- tabs -->
          <div>
            <ul class="nav nav-tabs">
              <li class="nav-item">
                <a
                  class="nav-link"
                  :class="{ active: nav == 1 }"
                  href="javascript:;"
                  @click="changeNav(1)"
                >
                  {{ $t("outside.我的商品相册") }}
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  :class="{ active: nav == 2 }"
                  href="javascript:;"
                  @click="changeNav(2)"
                >
                  {{ $t("outside.我的电脑") }}
                </a>
              </li>
            </ul>
          </div>
          <!-- 相册 -->
          <div v-show="nav == 1" class="pd-y-15">
            <div class="row mg-b-10">
              <div class="col-4">
                <v-select
                  class="style-chooser"
                  :placeholder="$t('outside.选择相册')"
                  :filterable="false"
                  :options="albumOptions"
                  v-model="selectedAlbum"
                  @search="searchAlbum"
                >
                  <template slot="no-options">
                    {{ $t("outside.输入要选择的相册名..") }}
                  </template>
                </v-select>
              </div>
              <div class="col-4 d-flex align-items-center">
                <input
                  type="text"
                  class="form-control form-control-sm mg-r-5"
                  :placeholder="$t('outside.在当前相册中寻找')"
                  v-model="keyName"
                  @keyup.enter="searchImg()"
                />
                <button
                  type="button"
                  class="btn btn-primary btn-sm"
                  @click="searchImg()"
                >
                  {{ $t("outside.搜索") }}
                </button>
              </div>
              <div class="col-4">
                <span class="d-inline-block form-control-sm">{{
                  $t("outside.请从你的相册中选择图片")
                }}</span>
              </div>
            </div>
            <div class="row">
              <ul v-if="items.length" class="row col-12 img-list">
                <li
                  v-for="item in items"
                  :key="item.id"
                  :class="max ? 'col-1' : 'col-2'"
                >
                  <div
                    class="img-wrap"
                    :class="{ active: isSelected(item) }"
                    v-lazy:background-image="item.imgUrl"
                    @click="selectImg(item)"
                  >
                    <div class="selected-mask">
                      <i class="icon ion-checkmark" aria-hidden="true"></i>
                    </div>
                    <div
                      v-if="item.illegal == 1"
                      class="illegal"
                      data-toggle="tooltip"
                      data-placement="top"
                      :data-original-title="
                        $t('outside.原因：') + item.illReason
                      "
                    >
                      <span class="tx-danger">
                        {{
                          item.auditStatus == "3"
                            ? $t("outside.违规")
                            : $t("outside.可能违规")
                        }}
                      </span>
                    </div>
                  </div>
                </li>
              </ul>
              <div v-else class="col-12 tx-16 tx-bold tx-center">
                {{ $t("outside.没有符合条件的图片") }}
                <span v-if="selectedAlbum" class="tx-normal tx-12">
                  （{{ $t("outside.相册：")
                  }}<span class="tx-gray-700">{{ selectedAlbum.label }}</span>
                  ）
                </span>
                <span v-if="keyName" class="tx-normal tx-12">
                  （{{ $t("outside.关键词：")
                  }}<span class="tx-gray-700">{{ keyName }}</span
                  >）
                </span>
              </div>
            </div>
            <div v-if="albumItems.length" class="row">
              <div
                class="col-12 d-flex justify-content-center align-items-center"
              >
                <innerPagination
                  class="mg-r-15"
                  :cur="page"
                  :all="totalPage"
                  :size="7"
                  @page="gotoPage"
                />
                <span class="tx-12"
                  >{{ $t("outside.共") }} {{ albumItems.length }}
                  {{ $t("outside.张") }}</span
                >
              </div>
            </div>
          </div>
          <!-- 上传 -->
          <div v-show="nav == 2" class="pd-y-15">
            <div class="row mg-b-10">
              <div class="col-12 d-flex align-items-center">
                <span class="mg-r-5">{{
                  $t("outside.选择要上传的相册：")
                }}</span>
                <v-select
                  class="style-chooser mg-r-15"
                  :placeholder="$t('outside.选择相册')"
                  :filterable="false"
                  :options="albumOptions"
                  v-model="selectedAlbumUpload"
                >
                  <template slot="no-options">
                    {{ $t("outside.输入要选择的相册名..") }}
                  </template>
                </v-select>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="uploadOpen()"
                >
                  <i class="mg-r-5 fa fa-upload" aria-hidden="true"></i>
                  {{ $t("outside.点击选择图片") }}
                </button>
                <input
                  type="file"
                  id="uploadProductPic"
                  :multiple="maxSelected > 1"
                  @change="fileChange($event)"
                />
              </div>
            </div>
          </div>
          <!-- 已选图片 -->
          <div class="selected-wrap" :class="{ 'mg-b-10': stocks }">
            <p>
              <span class="mg-r-15 tx-gray-700"
                >{{ $t("outside.已选图片") }}( {{ selectedItem.length }} /
                {{ maxSelected }} )</span
              >
              <span class="tx-12">{{
                $t("outside.(支持鼠标拖拽调整图片顺序)")
              }}</span>
            </p>
            <ul class="selected-list">
              <Draggable
                draggable=".dargDiv"
                :list="selectedItem"
                :options="{ animation: 300 }"
                group="tags"
                @change="spuFirst()"
              >
                <li
                  v-for="img in selectedItem"
                  :key="img"
                  class="dargDiv uns-tag"
                >
                  <div
                    class="img-wrap"
                    :class="{ error: isError(img), isIll: $isIll(img) }"
                    v-lazy:background-image="img"
                  >
                    <a
                      class="close"
                      href="javascript:;"
                      @click="removeImg(img)"
                    >
                      <i class="fa fa-times" aria-hidden="true"></i>
                    </a>
                    <a
                      v-if="!sku && stocks && stocks.length"
                      class="set-sku"
                      @click="setAllSkuImg(img)"
                      >{{ $t("outside.设为SKU图") }}</a
                    >
                    <div class="error">{{ $t("outside.图片不符合要求") }}</div>
                  </div>
                </li>
              </Draggable>
            </ul>
          </div>
          <!-- sku列表 -->
          <div v-if="!sku && stocks && stocks.length" class="row">
            <div class="col-12">
              <table class="table mg-b-0 table-contact">
                <thead>
                  <tr>
                    <th>
                      <div class="d-flex align-items-center">
                        <label class="ckbox mg-0">
                          <input
                            type="checkbox"
                            :checked="isAll"
                            @change="changeAllCheck($event)"
                          />
                          <span></span>
                        </label>
                        {{ $t("outside.SKU信息") }}
                      </div>
                    </th>
                    <th>{{ $t("outside.SKU编号") }}</th>
                    <th>
                      {{ $t("outside.供货价") }}（{{
                        ($CE[currency] || {}).symbol
                      }}）
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="obj in stocks" :key="obj.id" class="tx-12">
                    <td class="valign-middle">
                      <div class="d-flex align-items-center">
                        <label class="ckbox mg-b-0">
                          <input
                            type="checkbox"
                            :value="obj.id"
                            v-model="checkArr"
                          /><span></span>
                        </label>
                        <div class="pos-relative">
                          <div
                            class="img-wrap mg-r-15"
                            v-lazy:background-image="obj.tempImg"
                            href="javascript:;"
                          ></div>
                        </div>
                        <div>
                          <div>
                            {{ $t("outside.颜色：")
                            }}<span class="tx-gray-900">{{
                              obj.propertyValue
                                ? obj.propertyValue.split("||")[0]
                                : "---"
                            }}</span>
                          </div>
                          <div>
                            {{ $t("outside.尺码：")
                            }}<span class="tx-gray-900">{{
                              obj.propertyValue
                                ? obj.propertyValue.split("||")[1]
                                : "---"
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td class="valign-middle tx-gray-900">
                      {{ obj.sku ? obj.sku : "---" }}
                    </td>
                    <td class="valign-middle tx-gray-900">
                      {{
                        obj.salePrice
                          ? Number(obj.salePrice).toFixed(2)
                          : "0.00"
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="
              btn btn-primary
              tx-11 tx-uppercase
              pd-y-12 pd-x-25
              tx-mont tx-semibold
            "
            @click="save"
          >
            {{ $t("outside.保存") }}
          </button>
          <button
            type="button"
            class="
              btn btn-secondary
              tx-11 tx-uppercase
              pd-y-12 pd-x-25
              tx-mont tx-semibold
            "
            data-dismiss="modal"
          >
            {{ $t("outside.关闭") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { innerPagination } from "./../pagination.js"; //分页
import Draggable from "vuedraggable";
export default {
  name: "ModalUploadProductImages",
  props: [
    "open",
    "minSelected",
    "maxSelected",
    "imgRule",
    "spuId",
    "spuImages",
    "stocks",
    "loading",
    "sku",
    "spu",
    "type",
    "currency",
  ], //max必须有
  data() {
    return {
      modalLoading: false,
      max: true,
      maxH: 460,
      listLoading: false,
      nav: 1,
      albumOptions: [],
      selectedAlbum: null,
      selectedAlbumUpload: null,
      albumItems: [],
      page: 1,
      rowsPerPage: 12,
      selectedItem: [], // 已选择的图片
      keyName: "",
      maxSize: 1024 * 1024 * 2,
      checkArr: [],
      minSizeX: 1,
      minSizeY: 1,
      isFirstImg: false,
      errorImg: [],
      uploadType: "",
      openFirst: 0,
    };
  },
  components: {
    innerPagination,
    Draggable,
  },
  computed: {
    selectedItemLength() {
      this.openFirst++;
      return this.selectedItem.length;
    },
    items() {
      let items = [];
      for (let i = 0; i < this.rowsPerPage; i++) {
        if ((this.page - 1) * this.rowsPerPage + i < this.albumItems.length)
          items.push(this.albumItems[(this.page - 1) * this.rowsPerPage + i]);
      }
      return items;
    },
    totalPage() {
      return Math.ceil(this.albumItems.length / this.rowsPerPage);
    },
    isAll() {
      return this.checkArr.length == this.stocks.length &&
        this.stocks.length > 0
        ? true
        : false;
    },
  },
  watch: {
    open() {
      this.modalLoading = false;
      this.nav = 1;
      this.albumOptions = [];
      this.selectedAlbum = null;
      this.selectedAlbumUpload = null;
      this.albumItems = [];
      this.page = 1;
      this.selectedItem = [];
      this.errorImg = [];
      // 大小限制
      if (this.imgRule && this.imgRule.minSize) {
        this.minSizeX = this.imgRule.minSize.split("||").shift();
        this.minSizeY = this.imgRule.minSize.split("||").pop();
      }
      //sku显示的图片
      this.stocks.forEach((stock) => {
        this.$set(stock, "tempImg", stock.propertyImage);
      });
      if (this.sku) {
        //只操作sku
        this.stocks.forEach((stock) => {
          if (stock.sku == this.sku) {
            this.selectedItem.push(stock.propertyImage);
          }
        });
      } else {
        //spu
        if (this.spuImages && this.spuImages.length) {
          //原来spu有图片
          this.isFirstImg = false;
          this.spuImages.forEach((e) => {
            this.selectedItem.push(e);
          });
        } else {
          this.isFirstImg = true;
        }
      }
      this.keyName = "";
      this.checkArr = [];
      $("#modalUploadProductImages .modal-body").css({
        "max-height":
          ($(window).height() - 200 < 400 ? 400 : $(window).height() - 200) +
          "px",
      });
      $("#modalUploadProductImages").modal("show");
      this.getAlbumList();
      this.openFirst = 0;
    },
    selectedAlbum() {
      if (this.selectedAlbum) {
        this.keyName = "";
        this.getImgs(this.selectedAlbum.value);
      }
    },
    selectedItemLength() {
      if (this.openFirst <= 1) return;
      if (this.stocks.length) {
        let num1 = 0;
        this.stocks.forEach((stock) => {
          if (this.stocks[0].tempImg == stock.tempImg) {
            num1++;
          }
        });
        if (num1 == this.stocks.length) {
          let imgAvailable = "";
          //获取第一张可用图片
          this.selectedItem.some((img) => {
            if (this.errorImg.indexOf(img) < 0) {
              //不在违规中
              imgAvailable = img;
              return true;
            }
          });
          //sku图赋值为可用图片
          if (imgAvailable) {
            this.stocks.forEach((e) => {
              this.$set(e, "tempImg", imgAvailable);
            });
          }
          //  			this.stocks.forEach(stock => {
          //  				if(this.isError(this.selectedItem[0])){
          //  					console.log("error")
          //  				}else{
          //  					this.$set(stock, 'tempImg', this.selectedItem[0])
          //          	this.$set(stock, 'propertyImage', this.selectedItem[0])
          //  				}
          //	        })
        }
      }
    },
  },
  mounted() {
    $("#modalUploadProductImages").on("shown.bs.modal", () => {
      this.sizeHeight();
      $(window).on("resize", () => {
        this.sizeHeight();
      });
    });
    $("#modalUploadProductImages").on("hide.bs.modal", () => {
      $(window).off("resize");
    });
  },
  updated() {
    $('[data-toggle="tooltip"]').tooltip();
  },
  methods: {
    save() {
      //保存模态框回调
      //是否有非法图片
      let errorNum = 0;
      this.selectedItem.forEach((item) => {
        if (
          this.errorImg.some((e) => {
            return item == e;
          })
        ) {
          errorNum++;
        }
      });
      if (errorNum) {
        ShowTip(
          this.$t("outside.已选图片中存在") +
            `${errorNum}` +
            this.$t("outside.张不符合要求的图片,请处理后提交"),
          "danger"
        );
        return;
      }
      if (
        this.selectedItem.length < this.minSelected ||
        this.selectedItem.length > this.maxSelected
      ) {
        ShowTip(
          this.$t("outside.上传图片数量必须大于等于") +
            `${this.minSelected}` +
            this.$t("outside., 小于等于") +
            `${this.maxSelected}`,
          "danger"
        );
        return;
      }
      this.$emit("save", this.spuId, this.selectedItem, this.sku);
    },
    isError(img) {
      let s = false;
      this.errorImg.some((e) => {
        if (e == img) {
          s = true;
          return true;
        }
      });
      return s;
    },
    setAllSkuImg(img) {
      if (this.checkArr.length) {
        this.stocks.forEach((stock) => {
          if (
            this.checkArr.some((e) => {
              return e == stock.id;
            })
          ) {
            this.$set(stock, "tempImg", img);
            this.$set(stock, "propertyImage", img);
          }
        });
        this.checkArr = [];
      } else {
        ShowTip(this.$t("outside.请在下面先选择要操作的SKU"), "danger");
        return;
      }
    },
    changeAllCheck(e) {
      this.checkArr = [];
      if (e.target.checked) {
        this.stocks.forEach((e) => {
          this.checkArr.push(e.id);
        });
      }
    },
    fileChange(event) {
      //获取上传文件
      let files = [];
      Object.keys(event.target.files).forEach((key) => {
        files.push(event.target.files[key]);
      });
      if (!files.length) {
        return;
      }
      if (
        files.length + this.selectedItem.length > this.maxSelected &&
        this.maxSelected != 1
      ) {
        ShowTip(
          this.$t("outside.最多选择") +
            `${this.maxSelected}` +
            this.$t("outside.个文件"),
          "danger"
        );
        return;
      }
      this.uploadType = this.selectedAlbumUpload.type;
      //图片加入
      let i = 0;
      let upload = (key) => {
        //是否图片
        if (
          files[key].type.indexOf("image") < 0 &&
          files[key].size > this.maxSize
        ) {
          ShowTip(
            this.$t("outside.文件") +
              `${files[key].name}` +
              this.$t("outside.不是图片文件或者大于2MB"),
            "danger"
          );
          return;
        }
        i++;
        this.modalLoading = true;
        let name = "";
        if (this.selectedAlbumUpload && this.selectedAlbumUpload.value) {
          name = this.selectedAlbumUpload.label;
        } else {
          name = this.spu ? this.spu : "";
        }
        let params = {
          name,
          ext: files[key].name.split(".").pop(),
          size: files[key].size,
          imgName: files[key].name,
          type: this.uploadType ? this.uploadType : this.type,
        };
        let reader = new FileReader();
        reader.readAsDataURL(files[key]);
        reader.onload = (e) => {
          params.imgUrlBase64 = e.target.result.split("base64,").pop();
          $.api_call("api.SupplierAlbum.uploadAlbum", params, (r) => {
            if (i >= files.length) {
              this.modalLoading = false;
            }
            if (r.ErrorCode == "9999") {
              this.uploadType = params.type;
              let Img = new Image();
              Img.src = r.Data.Results.url;
              Img.onload = () => {
                if (this.imgRule && this.imgRule.isSquare) {
                  if (Img.width != Img.height) {
                    this.errorImg.push(r.Data.Results.url);
                  } else {
                    if (
                      Img.width < this.minSizeX ||
                      Img.height < this.minSizeY
                    ) {
                      this.errorImg.push(r.Data.Results.url);
                    }
                  }
                } else {
                  if (Img.width < this.minSizeX || Img.height < this.minSizeY) {
                    this.errorImg.push(r.Data.Results.url);
                  }
                }

                if (this.maxSelected == 1) {
                  //最大一张就替换
                  this.selectedItem = [r.Data.Results.url];
                } else {
                  this.selectedItem.push(r.Data.Results.url);
                }
                this.spuFirst();
              };
              this.selectedAlbumUpload = {
                label: r.Data.Results.name,
                value: r.Data.Results.id,
                type: params.type,
              };
              if (i < files.length) {
                upload(i);
                return;
              }
              this.nav = 1;
              this.albumOptions.push({
                label: r.Data.Results.name,
                value: r.Data.Results.id,
                type: params.type,
              });
              this.selectedAlbum = {
                label: r.Data.Results.name,
                value: r.Data.Results.id,
              };
              this.getImgs(r.Data.Results.id, true);
            } else {
              if (r.ErrorCode == "1002") {
                userFailure(this);
              } else {
                ShowTip(r.Message, "danger");
              }
            }
          });
        };
      };
      upload(i);
      document.getElementById("uploadProductPic").value = "";
    },
    uploadOpen() {
      document.getElementById("uploadProductPic").click();
    },
    searchImg() {
      this.getImgs(this.selectedAlbum.value);
    },
    removeImg(img) {
      //移除已选图片
      this.selectedItem.forEach((e, i) => {
        if (e == img) {
          this.selectedItem.splice(i, 1);
        }
      });
      if (!this.sku && this.isFirstImg && this.stocks && this.stocks.length) {
        this.stocks.forEach((e) => {
          if (!e.propertyImage && e.tempImg == img) {
            this.$set(e, "tempImg", "");
          }
        });
        this.spuFirst();
      }
    },
    selectImg(item) {
      //选择图片
      if (
        this.selectedItem.some((e) => {
          return e == item.imgUrl;
        })
      ) {
        //已经选择反选
        this.selectedItem.some((e, i) => {
          if (e == item.imgUrl) {
            this.selectedItem.splice(i, 1);
            return true;
          }
        });
        return false;
      }
      //违规不能选
      if (item.illegal == 1) {
        return false;
      }
      // 特殊客户-中国供应商-需验证图片比例
      if (item.isScaleFlag == 2) {
        ShowTip(
          this.$t("outside.图片要求比例5:7,当前比例错误，不支持上传"),
          "danger"
        );
        return false;
      }
      if (
        this.selectedItem.length >= this.maxSelected &&
        this.maxSelected != 1
      ) {
        ShowTip(
          this.$t("outside.最多选择") +
            `${this.maxSelected}` +
            this.$t("outside.张图片"),
          "danger"
        );
        return;
      }
      //验证图片分辨率
      let Img = new Image();
      Img.src = item.imgUrl;
      this.modalLoading = true;
      Img.onload = () => {
        this.modalLoading = false;
        //      if(Img.width < this.minSizeX || Img.height < this.minSizeY){
        //        this.errorImg.push(item.imgUrl);
        //      }
        if (this.imgRule && this.imgRule.isSquare) {
          if (Img.width != Img.height) {
            this.errorImg.push(item.imgUrl);
          } else {
            if (Img.width < this.minSizeX || Img.height < this.minSizeY) {
              this.errorImg.push(item.imgUrl);
            }
          }
        } else {
          if (Img.width < this.minSizeX || Img.height < this.minSizeY) {
            this.errorImg.push(item.imgUrl);
          }
        }
        if (this.maxSelected == 1) {
          //最大一张就替换
          this.selectedItem = [item.imgUrl];
        } else {
          this.selectedItem.push(item.imgUrl);
        }
        this.spuFirst();
      };
    },
    spuFirst() {
      if (this.isFirstImg && this.selectedItem.length && !this.sku) {
        //如果第一次设置spu图片
        //设sku图片为第一个可用图片
        let imgAvailable = "";
        //获取第一张可用图片
        this.selectedItem.some((img) => {
          if (this.errorImg.indexOf(img) < 0) {
            //不在违规中
            imgAvailable = img;
            return true;
          }
        });
        //sku图赋值为可用图片
        if (imgAvailable) {
          this.stocks.forEach((e) => {
            if (!e.propertyImage) this.$set(e, "tempImg", imgAvailable);
          });
        }
      } else {
        if (this.stocks.length) {
          let num1 = 0;
          this.stocks.forEach((stock) => {
            if (this.stocks[0].tempImg == stock.tempImg) {
              num1++;
            }
          });
          if (num1 == this.stocks.length) {
            let imgAvailable = "";
            //获取第一张可用图片
            this.selectedItem.some((img) => {
              if (this.errorImg.indexOf(img) < 0) {
                //不在违规中
                imgAvailable = img;
                return true;
              }
            });
            //sku图赋值为可用图片
            if (imgAvailable) {
              this.stocks.forEach((e) => {
                this.$set(e, "tempImg", imgAvailable);
                //		              this.$set(e, 'propertyImage', imgAvailable)
              });
            }
          }
        }
      }
    },
    getImgs(albumId, last) {
      //获取图片列表
      if (!albumId) {
        this.albumItems = [];
        return;
      }
      this.listLoading = true;
      this.page = 1;
      $.api_call("api.SupplierAlbum.findImgsBySupplier", { albumId }, (r) => {
        this.listLoading = false;
        if (r.ErrorCode == "9999") {
          if (this.keyName) {
            this.albumItems = [];
            r.Data.Results.forEach((e) => {
              if (e.name.indexOf(this.keyName) > -1) {
                this.albumItems.push(e);
              }
            });
          } else {
            this.albumItems = r.Data.Results;
          }
          if (last) {
            this.page = this.totalPage;
          }
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    searchAlbum(word) {
      this.getAlbumList(word);
    },
    getAlbumList(name) {
      //获取相册列表
      this.modalLoading = true;
      $.api_call(
        "api.SupplierAlbum.findBySupplier",
        { nameLike: name },
        (r) => {
          this.modalLoading = false;
          if (r.ErrorCode == "9999") {
            this.albumOptions = [];
            r.Data.Results.datas.forEach((e) => {
              this.albumOptions.push({
                label: e.name,
                value: e.id,
                type: e.type,
              });
            });
            //添加默认相册
            this.albumOptions.unshift({
              label: this.$t("outside.默认相册"),
              value: 0,
              type: this.type,
            });

            this.selectedAlbum = {
              label: this.$t("outside.默认相册"),
              value: 0,
            };
            this.selectedAlbumUpload = {
              label: this.$t("outside.默认相册"),
              value: 0,
              type: this.type,
            };
            if (this.spu) {
              //有spu相册名
              this.albumOptions.forEach((e) => {
                if (e.label == this.spu) {
                  this.selectedAlbum = {
                    label: e.label,
                    value: e.value,
                    type: e.type,
                  };
                  this.selectedAlbumUpload = {
                    label: e.label,
                    value: e.value,
                    type: e.type,
                  };
                }
              });
            }
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    isSelected(item) {
      let s = false;
      this.selectedItem.some((e) => {
        s = item.imgUrl == e;
        return s;
      });
      return s;
    },
    changeNav(nav) {
      this.nav = nav;
    },
    gotoPage(page) {
      this.page = page;
    },
    changeSize() {
      this.max = !this.max;
      $("#modalUploadProductImages .modal-dialog").removeAttr("style");
    },
    sizeHeight() {
      let wH = $(window).height(),
        hH = $("#modalUploadProductImages .modal-header").height(),
        fH = $("#modalUploadProductImages .modal-footer").height();
      this.maxH = wH - hH - fH - 160;
    },
  },
};
</script>

<style lang="less" scoped>
.nav {
  .nav-link.active,
  .nav-link.active:hover,
  .nav-link:visited,
  .nav-link:active {
    color: #333;
    background-color: #fff;
    border-bottom-color: #fff;
  }
  .nav-link:hover {
    color: #333;
    background-color: #e9ecef;
  }
}
.modal-body {
  min-height: 500px;
}
.img-list {
  display: flex;
  margin: 0;
  list-style: none;
  > li {
    margin-bottom: 10px;
    > .img-wrap {
      position: relative;
      border: 1px #ddd solid;
      width: 93px;
      height: 93px;
      background-size: cover;
      background-position: center;
      cursor: pointer;
      > .illegal {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(255, 255, 255, 0.6);
        span {
          position: absolute;
          top: 50%;
          left: 0;
          right: 0;
          transform: translateY(-50%);
          font-weight: bold;
          text-align: center;
          font-size: 12px;
        }
      }
      > .selected-mask {
        display: none;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.3);
        > i {
          position: absolute;
          bottom: 5%;
          right: 5%;
          /* -webkit-transform: translate(-50%, -50%); */
          /* transform: translate(-50%, -50%); */
          color: #fff;
          font-size: 14px;
          background: #17a2b8;
          border-radius: 100%;
          width: 20px;
          height: 20px;
          text-align: center;
        }
      }
    }
    > .img-wrap:hover,
    .img-wrap.active {
      border-color: #17a2b8;
    }
    > .img-wrap.active {
      border-width: 2px;
      > .selected-mask {
        display: block;
      }
    }
  }
}
.selected-wrap {
  padding: 5px;
  border: 1px #ddd solid;
  .selected-list {
    list-style: none;
    margin: 0;
    padding: 0;
    > div {
      display: flex;
      > li {
        margin: 0 10px 10px 0;
        .img-wrap {
          position: relative;
          width: 80px;
          height: 80px;
          border: 1px #17a2b8 solid;
          background-size: cover;
          background-position: center;
          cursor: pointer;
          > .close {
            display: none;
            position: absolute;
            top: 0;
            right: 0;
            width: 16px;
            height: 16px;
            line-height: 16px;
            text-align: center;
            background-color: #dc3545;
            color: #fff;
            font-size: 12px;
          }
          > .close:hover {
            opacity: 1;
            background-color: #d32535;
            color: #ddd;
          }
          .set-sku {
            position: absolute;
            bottom: 3px;
            left: 50%;
            transform: translateX(-50%);
            min-width: 70px;
            height: 22px;
            line-height: 22px;
            text-align: center;
            background-color: #17a2b8;
            color: #fff;
            font-size: 12px;
            opacity: 0.7;
          }
          .set-sku:hover {
            background-color: #138496;
          }
          .error {
            display: none;
            color: #dc3545;
            background-color: rgba(255, 255, 255, 0.6);
            font-size: 12px;
          }
        }
        .img-wrap:hover {
          > .close {
            display: block;
          }
          > .set-sku {
            opacity: 1;
          }
        }
        .img-wrap.error {
          border-color: #dc3545;
          .error {
            display: block;
            position: absolute;
            right: 0;
            bottom: 0;
            left: 0;
          }
          .set-sku {
            display: none;
          }
        }
      }
    }
  }
}
.dargDiv[draggable="true"] {
  opacity: 0.2;
}
.dargDiv.no-darg {
  cursor: auto;
}
.style-chooser {
  min-width: 150px;
}
#uploadProductPic {
  display: none;
}
.table {
  .img-wrap {
    width: 50px;
    height: 50px;
    background-size: cover;
    background-position: center;
  }
}
</style>
<style lang="less">
#modalUploadProductImages .vs__clear {
  display: none;
}
</style>